/// <reference path="google.recaptcha.d.ts"/>

/**
 * Async Loaded for Google Maps API
 * Wrap calls to google maps api in closure and pass to this function,
 * this will ensure that calls are only made when google maps is actually loaded,
 * without always loading it.
 *
 * @author Chris Seufert
 */

const DEBUG = false;

export default class AsyncApi {
  private static loaded = false;
  private static loading = false;
  private static callList = [];

  static onLoad(callback?: (recaptcha: ReCaptchaV2.ReCaptcha) => void) {
    if (this.loaded) {
      callback(grecaptcha);
    } else {
      if (callback) this.callList.push(callback);
      if (this.loading) {
        if (callback === undefined) {
          this.loaded = true;
          if (DEBUG) console.log('Finished Loading');
          while (this.callList.length) {
            const call = this.callList.shift();
            call(grecaptcha);
          }
          if (DEBUG) console.log('Finished Loading');
        }
      } else {
        this.loading = true;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.defer = true;
        script.async = true;
        script.src =
          'https://www.google.com/recaptcha/api.js?' +
          'onload=googleRecaptchaApiLoaded&render=explicit';
        document.body.appendChild(script);
        if (DEBUG) console.log('Loading Started');
      }
    }
  }
}

window['googleRecaptchaApiLoaded'] = () => AsyncApi.onLoad();
